import { BaseLayout } from "layouts/common/BaseLayout";
import { InsideLayoutProvider } from "layouts/common/inside/InsideLayoutProvider";
import { KnowledgeMenu } from "layouts/KnowledgeLayout/KnowledgeMenu";
import * as React from "react";
import { PropsWithChildren } from "react";
import { Outlet } from "react-router";

////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IAppProps {
    fullView?: boolean;
}

type Props = IAppProps & PropsWithChildren;

////////////////////////////////////////////////////////////////////////////////////////////////////////

export const KnowledgeLayout: React.FC<Props> = (props) => {
    return (
        <BaseLayout>
            <InsideLayoutProvider
                lateralMenu={<KnowledgeMenu />}
                showCloseButtonWhileMenuOpened={false}
            >
                <Outlet />
            </InsideLayoutProvider>
        </BaseLayout>
    );
};
